import BaseAPI from './base/base-api';

class PayFileAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'PaymentAPI';
	controllerName = 'file';

	/**
	 * Download file
	 */
	download(key) {
		let url = this.getAPIUrl() + '/download?key=' + key;
		let link = document.createElement('a');
		link.target = '_blank';
		link.href = url;
		link.click();
	}

	/**
	 * Download file
	 */
	print(key) {
		let url = this.getAPIUrl() + '/print?key=' + key;
		let link = document.createElement('a');
		link.target = '_blank';
		link.href = url;
		link.click();
	}
}

export default new PayFileAPI();
